import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

/* Dialogs */
import SelectProductsToAssignOverlayDialog from '../../dialogs/selectProductsToAssignOverlayDialog';
import SelectLayoutOverlayDialog from '../../dialogs/selectLayoutOverlayDialog';
import ReorderPagesOverlayDialog from '../../dialogs/reorderPagesOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
/*new brochure changes*/
import BrochureImportFileConfirmOverlayDialog  from '../../dialogs/brochureImportFileConfirmOverlayDialog';
/*end brochure changes*/
/* Actions */
import {
	addNewPage,
	updatePages,
	updateBrochureParameter,
	getSavedBrochures,
	getModelsBySalesAgreement,
	saveToList,
	getSearchKeywordSuggestionList,
	updateSelectedItems,
	resetBrochurePayload,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	/*new brochure change*/
	getBrochureTemplateOptions,
	getProductsFromS3,
	updateOtherAddedProducts
	/*end brochure change*/
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
const {
	product,
	productAPIUrl,
} = routes;
import {
	sendRequest
} from '../../../redux/api/sendRequest';

import ProductSortableComponent from './productSortable';

/*new brochure changes*/
const { s3BucketAPIBaseURL } = routes;
/*end brochure changes*/

class BrochureStep1 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedPageNumber: '',
			showSelectProductsToAssignOverlayDialog : false,
			showSelectLayoutOverlayDialog: false,
			atLeastOneProductAddedInOnePageError: '',
			pageTitleErrorDialog: '',
			showReorderPagesOverlayDialog: false,

			salesAgreement: '',
			salesAgreementError: '',
			selectedModels: '',
			selectedModelsError: '',

			showGenericOverlayDialog: false,
			
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			selectedProposal: '',
/*new brochure changes*/
			showBrochureImportFileConfirmOverlayDialog:false,
			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: '',
/*end brochure changes*/
		};
		this.sortEndOfProducts = this.sortEndOfProducts.bind(this);
		this.sortEndOfPages = this.sortEndOfPages.bind(this);
		this.handlePageTitleChange = this.handlePageTitleChange.bind(this);
		this.handleAssignProductsToPage = this.handleAssignProductsToPage.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleChangeBrochureCreateOption = this.handleChangeBrochureCreateOption.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleAddNewPage(event) {
		event.preventDefault();
		this.props.addNewPage();
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.getBrochureTemplateOptions();
	}

	handleAssignProductsToPage(pageNumber, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			selectedPageNumber: pageNumber,
			showSelectProductsToAssignOverlayDialog: false
		}, () => {
			self.setState({
				showSelectProductsToAssignOverlayDialog: true
			});
		});
	}

	handlePageTitleChange(pageNumber, event) {
		event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) {
				item.pageTitle = event.target.value;
			}
			return null;
		});
		this.props.updatePages(pages);
	}
	sortEndOfProducts(products, pageNumber, event) {
		event && event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) item.products = products;
			return null;
		});
		this.props.updatePages(pages);
	}
	sortEndOfPages(pages, event) {
		event && event.preventDefault();
		this.props.updatePages(pages);
	}
	handleRemoveItemFromPage = (pageNumber, productNumber, event) => {
		event && event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) {
				item.products = _.pullAllBy(item.products, [{ "productNumber": productNumber }], "productNumber");
				item.products.map((itm, ind) => {
					itm.sequence = ind + 1;
					return null;
				});
			}
			return null;
		});
		this.props.updatePages(pages);
	}
	handleContinue(event) {
		event.preventDefault();
		let { brochure } = this.props.state;
		var self = this,
			isThereAnyOnePage = false,
			atLeastOneProductAddedInOnePage = false,
			pageTitleError = false;
		let pattern= /^[^&\n]*?(?:\s&[^&\n]*)*$/
		brochure.payload.brochure.pages.map((item, index) => {
			if(item.products.length === 1)
				isThereAnyOnePage = true;
			if(item.products.length >= 1)
				atLeastOneProductAddedInOnePage = true;
			if(!pattern.test(item.pageTitle)){
				pageTitleError = true;
			}
			return null;
		});

		self.setState({
			atLeastOneProductAddedInOnePageError: ''
		})
		
		if(pageTitleError){
			self.setState({
	  		  pageTitleErrorDialog: "Error in page title. Please include a space before &."
			})
	  
			return null;
		}
		if(atLeastOneProductAddedInOnePage) {
			if(isThereAnyOnePage) {
				self.setState({
					showSelectLayoutOverlayDialog: false
				}, () => {
					self.setState({
						showSelectLayoutOverlayDialog: true
					})
				});
			} else {
				self.handleContinueNextStep('landscape');
			}
		} else {
			self.setState({
				atLeastOneProductAddedInOnePageError: 'Please select at least one product in one page.'
			})
		}
	}
	handleContinueNextStep(layoutMode, event) {
		event && event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages,
			updatedPages = [];
		pages.map((item, index) => {
			if(item.products.length >= 1)
				updatedPages.push(item);
			return null;
		});
		updatedPages.map((item, index) => {
			item.pageNumber = index + 1;
			return null;
		})
		this.props.updatePages(updatedPages);
		this.props.updateBrochureParameter({
			name: 'layout',
			value: layoutMode
		})
		browserHistory.push('/create-brochure-step2');
	}
	handleReOrderPages(event) {
		event.preventDefault()
		var self = this;
		self.setState({
			showReorderPagesOverlayDialog: false
		}, () => {
			self.setState({
				showReorderPagesOverlayDialog: true
			});
		});
	}

	/*new brochure change*/
	handleChangeFeatureCreateOption(event) {
		const self = this;
		const createFeatureOption = parseInt(event.target.value, 10);
		self.props.handleCreateFeature(createFeatureOption, 'step1');
	}

	handleBrochureTemplateOptions(indexes,pageNumber, event){
		event.preventDefault();
		let { brochure } = this.props.state;
		/*new brochure single change*/
		const { templateOptions } = brochure;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) {
				item.selectedTemplateOption = templateOptions.find((template) => template.templateName == event.target.value);
			}
			return null;
		});
		this.props.updatePages(pages);
	}

	handleImportAction(event) {
		const self = this;
		self.handleDialog('BrochureImportFileConfirmOverlayDialog', false, event);
		document.getElementById('file-input').click();
	}

	handleFileUpload(e) {
        e.preventDefault();
		
		let filTypes = ["xlsx", "xls","csv"]
        var self = this,
            files = e.target.files;
		self.setState({
				fileUploadStatusMessage: '',
				fileUploadStatus: false,
				fileUploadErrorMessage: ''
			});
        if (files.length > 0) {
            self.setState({
                fileUploadStatusMessage: 'Please wait until file is uploading.....',
                fileUploadStatus: true,
                fileUploadErrorMessage: ''
            });
            var file = files[0],
                reader = new FileReader();
				let fileType = file.name.split(".")[1]
				if(!filTypes.includes(fileType.toLowerCase())){
					self.setState({
						fileUploadStatusMessage: '',
						fileUploadStatus: true,
						fileUploadErrorMessage: 'Only the following file types are allowed: XLSX, XLS, and CSV.'
					});
					return;
				}
            reader.addEventListener('loadend', function (e) {
				const { userDetails } = self.props.state.user;
                fetch(s3BucketAPIBaseURL, {
                    method: "POST",
					headers: {
						'Content-Type': 'application/json',
						"Authorization": `${userDetails.jwt}${userDetails.sso}`
					},
                    body: JSON.stringify({
                        name:  "CustomerNet/tmp/" + file.name,
                        type: file.type
                    })
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
					var list = [];
                    list.push({
                        fileName: file.name,
                        fileURL: json.uploadURL
                    });
					self.setState({
						fileName: file.name
                    });
                    return fetch(json.uploadURL, {
                        method: "PUT",
                        body: new Blob([reader.result], {
                            type: file.type
                        })
                    })
                }).then(function () {
                    self.setState({
                        fileUploadStatusMessage: '',
                        fileUploadStatus: false,
                        fileUploadErrorMessage: ''
                    }, () => {
						self.fileUploadInput.value = null;
						self.fetchContentOfFile();
					});
                });
            });
            reader.readAsArrayBuffer(file);
        } else {
            self.setState({
                fileUploadStatusMessage: '',
                fileUploadStatus: false,
                fileUploadErrorMessage: ''
            });
        }
    }

	fetchContentOfFile() {
		const self = this;
		self.props.getProductsFromS3(`requestType=getProductsFromS3ForBrochure&s3FileName=${encodeURIComponent(self.state.fileName)}`, resp => {
			if(resp.status && resp.responseObject) {
				let response = resp.responseObject;
					if(response.status == true && response.item.length > 0){
						self.setState({
							genericDialogHeading: 'Success',
							genericDialogText: 'Models imported successfully',
							modalButtons: 'ok',
						}, () => {
							response.item.map((productDetail, index) => self.handleAddProductChange(index, productDetail))
							response.item
							self.handleDialog('GenericOverlayDialog', true);
						});
					}
					else{
						const combinedString = response.itemList.join(", ");
						let value = `These model numbers are not present in CustomerNet, please review the file and ensure all model numbers are present in CustomerNet. ${combinedString}`
						self.setState({
							genericDialogHeading: 'Error',
							genericDialogText: value,
							modalButtons: 'ok',
						}, () => {
							self.handleDialog('GenericOverlayDialog', true);
						});
					}
			} else {
				 
				browserHistory.push('/error');
			}
		});
	}

	handleAddProductChange(itemIndex, productDetails) {
		const self = this;
		var selectedItems = self.props.state.brochure.selectedItems;
        selectedItems.push({
			itemType: productDetails.itemType,
			item: productDetails.sku,
			quantity: 1,
			itemDescription: productDetails.description,
			price: ""
		});
		self.props.updateSelectedItems(selectedItems);
	}
	/*end brochure change*/

	handleChangeBrochureCreateOption(event) {
        const self = this;
		const { brochure } = self.props.state;
		const { selectedBrochureCreateOption } = brochure;
		const createBrochureOption = parseInt(event.target.value, 10);
		if (selectedBrochureCreateOption === createBrochureOption) {
			event.preventDefault && event.preventDefault();
			return null;
		}

		if (createBrochureOption !== 3) {
			self.setState({
				salesAgreement: '',
				salesAgreementError: '',
			});
		}
		// if(createBrochureOption !== 4) {
		// 	self.setState({
		// 		selectedModels: '',
		// 		selectedModelsError: '',
		// 	});
		// }

		if (createBrochureOption === 1) {
			self.props.handleCreateBrochure(createBrochureOption, 'step1');
		} else if (createBrochureOption === 2) {
			const payload = JSON.parse(JSON.stringify(self.props.state.list.list));
	        payload.responseObject.wishlistItems.forEach((item, index) => {
	            item.selected = true;
	        });
	        self.props.saveToList(payload);
			setTimeout(() => {
				self.props.handleCreateBrochure(createBrochureOption, 'step1');
			}, 100);
		} else {
			self.props.handleCreateBrochure(createBrochureOption, 'step1');
		}
	}
	onChangeUpdateParam(event) {
		const self = this;

		const { name, value } = event.target;
		self.setState({
			[name]: value,
			[`${name}Error`]: '',
		}, () => {
			if (name === 'salesAgreement' && value) {
				self.props.updateSelectedItems([]);
				let accountNumber = self.props.getSelectedAccountNumber();
				self.props.resetBrochurePayload(accountNumber);
				const salesAgreementNumber = JSON.parse(value)['AGREEMENT_NUMBER'];
				self.handleChangeBrochureCreateOption({target:{value:3}});
				self.props.getModelsBySalesAgreement(`requestType=getQuoteModels&accountNumber=${accountNumber}&salesAgreement=${salesAgreementNumber}`, (response) => {
					if(response.status) {
						if (response.responseObject && response.responseObject.length) {
							response.responseObject = response.responseObject.map(item=> item.item_number);
							let keywords = response.responseObject.map(item => item.trim());
							keywords = _.chunk(keywords, 10);
							const promises = [];
							self.props.ajaxRequestInitiated();
							keywords.forEach(item => {
								promises.push(
									sendRequest(
										productAPIUrl,
										product.getKeyWordSuggession.path,
										'',
										product.getKeyWordSuggession.method,
										`requestType=getItems&keyword=${item.join(' ')}&accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${self.props.getZipCode()}&page=search`
									)
								);
							});
							Promise.all(promises).then((responses) => {
								// logic to combine all responses and then run call back
								let responseObject = [];
								let response = {};
								if(responses.length > 0) {
									responses.forEach(resp => {
										responseObject = responseObject.concat(resp.responseObject);
									});
									response = {
										...responses[0],
										responseObject
									}
								} else {
									response.responseObject = [];
								}
								self.props.ajaxRequestCompleted();

								let selectedItems = [];
								response.responseObject.forEach(itm => {
									selectedItems.push({
										...itm,
										item: itm.sku,
										itemDescription: itm.description,
									});
								});
								selectedItems = _.orderBy(selectedItems, ['item'], ['asc']);
								self.props.updateSelectedItems(selectedItems);
								self.props.resetBrochurePayload(self.props.getSelectedAccountNumber());
							});
						} else {
							self.setState({
								genericDialogHeading: 'Quote',
								genericDialogText: 'No models found in the quote',
								modalButtons: 'ok',
							}, () => {
								self.handleDialog('GenericOverlayDialog', true);
							});
						}
					}
				});
			}
		});
	}

	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}

	getModels(event) {
		event.preventDefault();
		const self = this;
		const { selectedModels } = self.state;
		if (selectedModels.trim() === '') {
			self.setState({
				selectedModelsError: 'error'
			});
		} else {
			self.props.getSavedBrochures(`requestType=getQuoteModels&proposal=${selectedModels.toUpperCase().trim()}`, (response) => {
				if(response.status) {
					if (response.responseObject && response.responseObject.length) {
						const keywords = response.responseObject.filter(itm =>{
							if(!self.isMService(itm)){
								return itm
							}
						}).map(item => item.trim()).join(' ');
						self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${keywords}&accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${self.props.getZipCode()}&page=search`, resp => {
							let selectedItems = [];
							resp.responseObject.forEach(itm => {
								selectedItems.push({
									...itm,
									item: itm.sku,
									itemDescription: itm.description,
								});
							});
							selectedItems = _.orderBy(selectedItems, ['item'], ['asc']);
							self.props.updateSelectedItems(selectedItems);
							self.props.resetBrochurePayload(self.props.getSelectedAccountNumber());
							self.setState({
								selectedProposal: self.state.selectedModels.toUpperCase().trim()
							});
						}, true);
					} else {
						self.setState({
							genericDialogHeading: 'Proposal',
							genericDialogText: 'Quote not found for the given proposal',
							modalButtons: 'ok',
							selectedProposal: '',
						}, () => {
							self.handleDialog('GenericOverlayDialog', true);
						});
					}
				}
			});
		}
	}
	render() {
		const self = this;
		const { brochure, list, user } = this.props.state;
		/*new brochure single change*/
		const { radioOptions, selectedBrochureCreateOption, selectedItems, featureTypes, templateOptions } = brochure;
		const selectedProductsCount = selectedItems.length;
		let listCount = 0;
		if(list && list.list && list.list.responseObject && list.list.responseObject.wishlistItems) {
			listCount = list.list.responseObject.wishlistItems.length;
		}
		let defaultAvailableCreateBrochureOptionsCount = 1;
		if (listCount) {
			defaultAvailableCreateBrochureOptionsCount++;
		}
		if (user.userDetails.typeOfUser === 'employee') {
			defaultAvailableCreateBrochureOptionsCount++;
		}
		{/*new brochure change*/}
		const { salesAgreementError, selectedModelsError, selectedProposal, salesAgreement } = self.state;
		{/*end brochure change*/}
		let selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources && self.props.state.user.selectedAccountsAllPriceSources.responseObject ? JSON.parse(JSON.stringify(self.props.state.user.selectedAccountsAllPriceSources.responseObject)) : [];
		selectedAccountsAllPriceSources = selectedAccountsAllPriceSources.filter(item => item['Quote Type'] === 'Q' || item['Quote Type'] === 'M' || item['Quote Type'] === 'U');
		if (selectedAccountsAllPriceSources.length) {
			defaultAvailableCreateBrochureOptionsCount++;
		}
		let selectedAgreement = '';
		if (salesAgreement) {
			selectedAgreement = JSON.parse(salesAgreement).AGREEMENT_NAME;
		}
		return (
			<div>
				<div className="push"><h1>{brochure.payload.brochure.brochureId?"Edit":"Create"} Brochure</h1></div>
				{<div className="bold" style={{padding: '0 1px'}}>Choose a way to add models to your brochure from the options below:</div>}
				{<table className="radioOptions" cellPadding={0} cellSpacing={0} width="100%">
					<tbody>
						<tr>
							<td>
								{radioOptions.map((item, index) => {
									if (item.value === 2 && listCount === 0) return null;
									if (item.value === 3 && selectedAccountsAllPriceSources.length === 0) return null;
									return <div key={ index } className="fullCell">
										<input type="radio" value={item.value} onClick={this.handleChangeBrochureCreateOption.bind(this)} name="create_brochure_options" id={item.id} checked={ item.checked } />
										<label htmlFor={item.id}>{item.label}</label>
										{item.value === 3 &&
											<select value={salesAgreement} className={salesAgreementError} name="salesAgreement" style={{marginLeft: '5px'}} onChange={this.onChangeUpdateParam.bind(this)}>
												<option value="" key={0}>-- Select --</option>
												{selectedAccountsAllPriceSources.map((item, index) => {
													return <option value={JSON.stringify(item)} key={(index + 1)}>{item.AGREEMENT_NAME}</option>
												})}
											</select>
										}
										{item.value === 4 && <input type="text" className={selectedModelsError} placeholder='Enter Reference Number' name="selectedModels" onFocus={() => this.handleChangeBrochureCreateOption({target:{value:4}})} 
										onChange={this.onChangeUpdateParam.bind(this)} style={{marginLeft: '5px'}} />}
										{item.value === 4 && <input type="button" value="GET MODELS" onClick={this.getModels.bind(this)} className="blueButton" style={{marginLeft: '15px'}} />}
										{item.value === 4 && selectedModelsError && <p className="red bold">Please enter a valid proposal number</p> }
{/*new brochure changes*/}
										{item.value === 5 && 
											<input type="button" value="IMPORT FILE" className="blueButton" disabled={selectedBrochureCreateOption != 5}
											 onClick={() => this.handleDialog('BrochureImportFileConfirmOverlayDialog', true)} style={{marginLeft: '15px'}}/>
										}
										{item.value === 5 && 
										<div>
										<div className="clear" />
										{this.state.fileUploadErrorMessage?<p className="red"><b>{this.state.fileUploadErrorMessage}</b></p>:null}
										{this.state.fileUploadStatusMessage?<p className="bold">{this.state.fileUploadStatusMessage}</p>:null}
											</div>}
										{/*end brochure changes*/}
									</div>
								})}
							</td>
						</tr>
					</tbody>
				</table>}
				
				<h2 className="pageTitle">Step 1 of 4: Assign Products to Pages</h2>
				<hr className="clear" />
				{/*new brochure change*/}
				<div>
					{brochure.payload.brochure.brochureId
						?<p className="floatLeft">You have <strong>{selectedProductsCount} products</strong> in the brochure.</p>
						:null
					}
					{!brochure.payload.brochure.brochureId &&
						<p className="floatLeft">
							{selectedBrochureCreateOption === 1 && <span>Click the Assign Products link associated with a page to add models to a brochure.</span>}
							{selectedBrochureCreateOption === 2 && <span>You have imported <strong>{selectedProductsCount} products</strong> from your list.<br />Click Assign Products to see them.</span>}
							{selectedBrochureCreateOption === 3 && <span><strong>You have imported {selectedProductsCount} models from sales agreement:</strong> {selectedAgreement}<br />Click Assign Products to see them.</span>}
							{selectedBrochureCreateOption === 4 && <span><strong>You have imported {selectedProductsCount} models from proposal:</strong> {selectedProposal}<br />Click Assign Products to see them.</span>}
						</p>
					}
					
				</div>
				<div className="push">
					<p className="floatRight"><a href="#" onClick={this.handleReOrderPages.bind(this)}>Reorder Pages</a></p>
				</div>

				<div className="push">
					<p className="floatRight topPageaddNewPageParagraph">
							<a href="#" className="addNewPageLink withIcon withAddIcon bold uppercase noUnderline" onClick={this.handleAddNewPage.bind(this)}>Add New Page</a>
					</p>
					<div className="clear" />
				</div>

				
				{defaultAvailableCreateBrochureOptionsCount > 1 && 
				<div className="featureOption">
					<div className="bold" style={{padding: '0 1px'}}>Choose how features will be displayed:</div>
					<table cellPadding={0} cellSpacing={0} width="100%">
						<tbody>
							<tr>
								<td>
									{featureTypes.map((item, index) => {
										return <div key={ index } className="fullCell">
											<input type="radio" value={item.value} onClick={this.handleChangeFeatureCreateOption.bind(this)} name="create_feature_options" id={item.id} checked={ item.checked } />
											<label htmlFor={item.id}>{item.label}</label>
										</div>
									})}
								</td>
							</tr>
						</tbody>
					</table>
				</div>}
				{/*end brochure change*/}
				
				<p className="bold red">{this.state.atLeastOneProductAddedInOnePageError}</p>
				<p className="bold red">{this.state.pageTitleErrorDialog}</p>
				<form className="reorderPagesForm" name="reorderPagesFrom" id="reorderPagesForm" onSubmit={(e) => e.preventDefault()}>
					<div className="pagesToReorder sortable ui-sortable">
						{/*Below code is for without sortable for pages start*/}
						{brochure.payload.brochure.pages.map((page, index) => {
							{/*new brochure change*/}
							if(!page.selectedTemplateOption){
								page.selectedTemplateOption = {templateName:"House of Brands Template"};
							}
							{/*end brochure change*/}
							return <div className="pageToReorder" key={index}>
								<p className="assignProductsParagraph">
									<a href="#" onClick={this.handleAssignProductsToPage.bind(this, page.pageNumber)} className="withIcon withAddIcon bold uppercase noUnderline">Assign Products</a>
								</p>
								<h3 className="pageNumber">Page {page.pageNumber}</h3>
								<div className="clear" />
								<input maxLength={20} className="almostFullWidth" name="page1title" onChange={this.handlePageTitleChange.bind(this, page.pageNumber)} value={page.pageTitle} placeholder="Page Title (optional)" type="text" />
								{/*new brochure change*/}
								{templateOptions && templateOptions.length > 0 && <select value={page.selectedTemplateOption.templateName} onChange={this.handleBrochureTemplateOptions.bind(this, index, page.pageNumber)} name="selectedTemplateOption" className="brochureOptionsTemplate">
										{templateOptions.map((item, index) => {
											return <option value={item.templateName} key={(index + 1)}>{item.templateName}</option>
										})}
									</select>
								}
								{/*end brochure change*/}
								<p className="maxProductsPerPageNotice">
									Maximum 5 products per page
								</p>
								<ProductSortableComponent handleRemoveItemFromPage={this.handleRemoveItemFromPage} sortEndOfProducts={this.sortEndOfProducts} items={page.products} pageNumber={page.pageNumber} />
								<p className="instructions">Rearrange products by dragging them.</p>
							</div>
						})}
					</div>

					<div className="clear" />
					<p className="floatLeft addNewPageParagraph">
							<a href="#" className="addNewPageLink withIcon withAddIcon bold uppercase noUnderline" onClick={this.handleAddNewPage.bind(this)}>Add New Page</a>
					</p>
					<p className="floatRight">
						<input className="blueButton" onClick={this.handleContinue.bind(this)} value="Continue" type="button" />
					</p>
					<div className="clear" />
				</form>
				{this.state.showSelectProductsToAssignOverlayDialog?<SelectProductsToAssignOverlayDialog selectedPageNumber={this.state.selectedPageNumber}/>:null}
				{this.state.showSelectLayoutOverlayDialog?<SelectLayoutOverlayDialog brochure={brochure.payload.brochure} handleContinueNextStep={this.handleContinueNextStep.bind(this)} />:null}
				{this.state.showReorderPagesOverlayDialog?<ReorderPagesOverlayDialog />:null}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
{/*new brochure changes*/}
				{this.state.showBrochureImportFileConfirmOverlayDialog?<BrochureImportFileConfirmOverlayDialog handleDialog={this.handleDialog.bind(this)} handleImportAction={this.handleImportAction.bind(this)} showDialog={true} />:null}
				<input ref={(input) => this.fileUploadInput = input} id="file-input" style={{display: 'none'}} accept=".xlsx, .xls, .csv" onChange={this.handleFileUpload.bind(this)} type="file" />
{/*end brochure changes*/}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	addNewPage: () => dispatch(addNewPage()),
	updatePages: (payload) => dispatch(updatePages(payload)),
	updateSelectedItems: (data) => dispatch(updateSelectedItems(data)),
	saveToList: (payload) => dispatch(saveToList(payload)),
	updateBrochureParameter: (payload) => dispatch(updateBrochureParameter(payload)),
	/*new brochure change*/
	getBrochureTemplateOptions: () => dispatch(getBrochureTemplateOptions()),
	getProductsFromS3: (queryString, callback) => dispatch(getProductsFromS3(queryString, callback)),
	updateOtherAddedProducts: (payload) => dispatch(updateOtherAddedProducts(payload)),
	/*end brochure change*/
	getSavedBrochures: (queryStringParams, callback) => dispatch(getSavedBrochures(queryStringParams, callback)),
	getModelsBySalesAgreement : (queryStringParams, callback) => dispatch(getModelsBySalesAgreement(queryStringParams, callback)),
	getSearchKeywordSuggestionList: (payload, callback, showloader) => dispatch(getSearchKeywordSuggestionList(payload, callback, showloader)),
	resetBrochurePayload: (accountNumber) => dispatch(resetBrochurePayload(accountNumber)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
});

BrochureStep1 = connect(mapStateToProps, mapDispatchToProps)(BrochureStep1);
export default BrochureStep1;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/step1.js